import React, { useEffect } from 'react';
import { ChevronDown, AlertTriangle, Clock, ShieldCheck, Hammer, Wrench, Zap, CheckCircle2, ChevronRight, Menu } from 'lucide-react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { PurchaseNotification } from './components/PurchaseNotification';
import { TestimonialCard } from './components/TestimonialCard';
import { PricingCard } from './components/PricingCard';
export function App() {
  // Initialize Meta Pixel
  useMetaPixel('2411207615977952');
  const scrollToPurchase = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-stone-50 font-sans text-stone-900 overflow-x-hidden" data-id="element-0">
      <PurchaseNotification data-id="element-1" />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-stone-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-40 md:hidden flex justify-between items-center" data-id="element-2">
        <div className="flex flex-col" data-id="element-3">
          <span className="text-xs text-stone-500 uppercase font-bold" data-id="element-4">
            Oferta Limitada
          </span>
          <span className="font-bold text-orange-600" data-id="element-5">$19.999</span>
        </div>
        <button onClick={scrollToPurchase} className="bg-orange-600 text-white px-6 py-3 rounded-lg font-bold shadow-lg hover:bg-orange-700 transition-colors" data-id="element-6">
          COMPRAR AHORA
        </button>
      </div>

      {/* Header/Nav */}
      <nav className="bg-stone-900 text-white py-3 px-4 sticky top-0 z-30 shadow-md" data-id="element-7">
        <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-8">
          <div className="font-black text-xl tracking-tighter flex items-center gap-2" data-id="element-9">
            <Hammer className="w-5 h-5 text-orange-500" data-id="element-10" />
            <span data-id="element-11">BIBLIA DEL CONSTRUCTOR</span>
          </div>
          <button onClick={scrollToPurchase} className="hidden md:block bg-orange-600 hover:bg-orange-700 text-white px-5 py-2 rounded font-bold transition-colors text-sm" data-id="element-12">
            ACCESO INMEDIATO
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="bg-stone-900 text-white pt-10 pb-16 px-4 relative overflow-hidden" data-id="element-13">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/concrete-wall.png')]" data-id="element-14"></div>
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-15">
          <div className="inline-block bg-orange-600 text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-6 animate-pulse" data-id="element-16">
            Oferta Especial Hoy
          </div>
          <h1 className="text-4xl md:text-6xl font-black mb-4 leading-tight" data-id="element-17">
            La Biblia del Constructor
          </h1>

          <div className="max-w-2xl mx-auto mb-8 transform hover:scale-[1.02] transition-transform duration-500 cursor-pointer" onClick={scrollToPurchase} data-id="element-18">
            <img src="https://cdn.magicpatterns.com/uploads/iYuUtcnPfgT2sg97bfqxPn/ChatGPT_Image_19_ene_2026,_05_21_19_p.m..png" alt="La Biblia del Constructor Pack Completo" className="w-full rounded-xl shadow-2xl border-4 border-stone-700" data-id="element-19" />
          </div>

          <h2 className="text-xl md:text-2xl font-bold text-orange-400 mb-6" data-id="element-20">
            Albañilería + plomería + electricidad, paso a paso
          </h2>

          <p className="text-xl md:text-2xl text-stone-200 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-21">
            Ahorrá{' '}
            <span className="text-white font-black bg-orange-600 px-1" data-id="element-22">
              TIEMPO
            </span>{' '}
            y{' '}
            <span className="text-white font-black bg-green-600 px-1" data-id="element-23">
              DINERO
            </span>{' '}
            evitando errores que te obligan a romper y rehacer.
          </p>

          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8 mb-10 text-left md:text-center max-w-2xl mx-auto" data-id="element-24">
            <div className="flex items-center gap-2" data-id="element-25">
              <CheckCircle2 className="text-green-400 shrink-0" data-id="element-26" />
              <span data-id="element-27">Paso a paso + checklists</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-28">
              <CheckCircle2 className="text-green-400 shrink-0" data-id="element-29" />
              <span data-id="element-30">Menos retrabajo</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-31">
              <CheckCircle2 className="text-green-400 shrink-0" data-id="element-32" />
              <span data-id="element-33">Usalo hoy desde el celular</span>
            </div>
          </div>

          <button onClick={scrollToPurchase} className="w-full md:w-auto bg-orange-600 hover:bg-orange-500 text-white text-xl md:text-2xl font-black py-5 px-10 rounded-xl shadow-[0_6px_0_rgb(154,52,18)] active:shadow-none active:translate-y-1 transition-all flex items-center justify-center gap-3 mx-auto" data-id="element-34">
            QUIERO LA BIBLIA DEL CONSTRUCTOR
            <ChevronRight className="w-6 h-6" data-id="element-35" />
          </button>
          <p className="mt-4 text-sm text-stone-400 flex items-center justify-center gap-2" data-id="element-36">
            <Zap className="w-4 h-4 text-yellow-400" data-id="element-37" /> Descarga inmediata • Se
            usa en el celular • Ideal para obra real
          </p>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-white" data-id="element-38">
        <div className="max-w-3xl mx-auto" data-id="element-39">
          <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-lg mb-10" data-id="element-40">
            <h3 className="text-2xl font-bold text-red-800 mb-2 flex items-center gap-2" data-id="element-41">
              <AlertTriangle className="w-6 h-6" data-id="element-42" />
              Si en una obra perdés tiempo… estás perdiendo plata
            </h3>
          </div>

          <p className="text-lg text-stone-700 mb-6 leading-relaxed" data-id="element-43">
            En construcción, el problema casi nunca es "no saber". El problema
            es hacer fuera de orden, no revisar a tiempo y terminar en lo de
            siempre:{' '}
            <span className="font-bold text-red-600" data-id="element-44">romper y rehacer.</span>
          </p>

          <p className="text-lg text-stone-700 mb-8 font-medium" data-id="element-45">
            Eso se traduce en:
          </p>

          <ul className="space-y-4 mb-10" data-id="element-46">
            {['más horas de laburo', 'más materiales', 'más idas y vueltas', 'más reclamos', 'menos ganancia'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg text-stone-800" data-id="element-47">
                <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center shrink-0" data-id="element-48">
                  <span className="text-red-600 font-bold" data-id="element-49">✕</span>
                </div>
                {item}
              </li>)}
          </ul>

          <div className="bg-stone-900 text-white p-8 rounded-xl text-center shadow-xl transform rotate-1" data-id="element-50">
            <p className="text-xl font-bold mb-4" data-id="element-51">
              ¿Cansado de tirar plata en errores evitables?
            </p>
            <button onClick={scrollToPurchase} className="bg-orange-600 hover:bg-orange-500 text-white font-bold py-3 px-8 rounded-lg shadow-lg transition-colors w-full md:w-auto" data-id="element-52">
              SÍ, QUIERO EVITAR ERRORES
            </button>
          </div>
        </div>
      </section>

      {/* Promise Section */}
      <section className="py-16 px-4 bg-stone-100 border-y border-stone-200" data-id="element-53">
        <div className="max-w-3xl mx-auto" data-id="element-54">
          <p className="text-xl text-stone-700 mb-8 text-center" data-id="element-55">
            Con{' '}
            <span className="font-bold text-orange-700" data-id="element-56">
              La Biblia del Constructor
            </span>{' '}
            vas a cortar el "romper y rehacer" usando un sistema simple:
          </p>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-57">
            <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-green-500" data-id="element-58">
              <Clock className="w-10 h-10 text-green-600 mb-4" data-id="element-59" />
              <h3 className="text-xl font-bold mb-3" data-id="element-60">Ahorrás tiempo</h3>
              <p className="text-stone-600" data-id="element-61">
                Porque sabés exactamente qué hacer y qué revisar en cada etapa.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-green-500" data-id="element-62">
              <ShieldCheck className="w-10 h-10 text-green-600 mb-4" data-id="element-63" />
              <h3 className="text-xl font-bold mb-3" data-id="element-64">Ahorrás dinero</h3>
              <p className="text-stone-600" data-id="element-65">
                Porque evitás errores que te hacen comprar dos veces o pagar
                mano de obra extra.
              </p>
            </div>
          </div>

          <p className="text-center mt-8 text-2xl font-black text-stone-800 uppercase tracking-wide" data-id="element-66">
            No es motivación. Es método.
          </p>
        </div>
      </section>

      {/* Target Audience */}
      <section className="py-16 px-4 bg-white" data-id="element-67">
        <div className="max-w-3xl mx-auto" data-id="element-68">
          <h2 className="text-3xl font-black text-stone-900 mb-10 text-center" data-id="element-69">
            ¿Para quién es?
          </h2>

          <div className="space-y-6" data-id="element-70">
            {[{
            icon: <Hammer className="w-6 h-6" data-id="element-71" />,
            text: 'Estás construyendo tu casa y querés controlar la obra y evitar gastos sorpresa.'
          }, {
            icon: <Wrench className="w-6 h-6" data-id="element-72" />,
            text: 'Sos albañil, plomero o electricista y querés hacer trabajos más rápidos, prolijos y con menos reclamos.'
          }, {
            icon: <ShieldCheck className="w-6 h-6" data-id="element-73" />,
            text: 'Sos contratista y querés un estándar de trabajo para no perder tiempo ni plata.'
          }].map((item, i) => <div key={i} className="flex gap-4 items-start p-4 rounded-lg hover:bg-stone-50 transition-colors border border-transparent hover:border-stone-200" data-id="element-74">
                <div className="bg-orange-100 p-3 rounded-full text-orange-600 shrink-0" data-id="element-75">
                  {item.icon}
                </div>
                <p className="text-lg text-stone-800 font-medium pt-2" data-id="element-76">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Product Breakdown */}
      <section className="py-16 px-4 bg-stone-900 text-white" data-id="element-77">
        <div className="max-w-4xl mx-auto" data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-black mb-4 text-center" data-id="element-79">
            ¿Qué es exactamente?
          </h2>
          <p className="text-xl text-stone-400 mb-12 text-center" data-id="element-80">
            La Biblia del Constructor es un pack digital en 3 tomos (hecho para
            usar en obra):
          </p>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-81">
            {/* Tomo 1 */}
            <div className="bg-stone-800 rounded-xl p-6 border border-stone-700 hover:border-orange-500 transition-colors" data-id="element-82">
              <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center mb-4 font-black text-2xl" data-id="element-83">
                1
              </div>
              <h3 className="text-xl font-bold mb-2 text-orange-400" data-id="element-84">
                Albañilería
              </h3>
              <p className="text-sm text-stone-400 mb-4 uppercase tracking-wider font-bold" data-id="element-85">
                paso a paso
              </p>
              <ul className="space-y-3 text-sm text-stone-300" data-id="element-86">
                <li className="flex gap-2" data-id="element-87">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-88" />{' '}
                  Orden correcto de trabajo y puntos críticos
                </li>
                <li className="flex gap-2" data-id="element-89">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-90" />{' '}
                  Niveles, replanteo, mezclas, revoques y terminaciones
                </li>
                <li className="flex gap-2" data-id="element-91">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-92" />{' '}
                  Errores típicos que generan fisuras, parches y retrabajo
                </li>
                <li className="flex gap-2" data-id="element-93">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-94" />{' '}
                  Checklists por etapa para no saltearte nada
                </li>
              </ul>
            </div>

            {/* Tomo 2 */}
            <div className="bg-stone-800 rounded-xl p-6 border border-stone-700 hover:border-blue-500 transition-colors" data-id="element-95">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4 font-black text-2xl" data-id="element-96">
                2
              </div>
              <h3 className="text-xl font-bold mb-2 text-blue-400" data-id="element-97">Plomería</h3>
              <p className="text-sm text-stone-400 mb-4 uppercase tracking-wider font-bold" data-id="element-98">
                sin pérdidas ni "romper después"
              </p>
              <ul className="space-y-3 text-sm text-stone-300" data-id="element-99">
                <li className="flex gap-2" data-id="element-100">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-101" />{' '}
                  Cómo planificar recorridos y conexiones
                </li>
                <li className="flex gap-2" data-id="element-102">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-103" />{' '}
                  Uniones, sellos y controles básicos
                </li>
                <li className="flex gap-2" data-id="element-104">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-105" />{' '}
                  Checklist antes de tapar/cerrar pared
                </li>
                <li className="flex gap-2" data-id="element-106">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-107" />{' '}
                  Guías rápidas para baño y cocina
                </li>
              </ul>
            </div>

            {/* Tomo 3 */}
            <div className="bg-stone-800 rounded-xl p-6 border border-stone-700 hover:border-yellow-500 transition-colors" data-id="element-108">
              <div className="w-12 h-12 bg-yellow-600 rounded-lg flex items-center justify-center mb-4 font-black text-2xl" data-id="element-109">
                3
              </div>
              <h3 className="text-xl font-bold mb-2 text-yellow-400" data-id="element-110">
                Electricidad
              </h3>
              <p className="text-sm text-stone-400 mb-4 uppercase tracking-wider font-bold" data-id="element-111">
                prolija, ordenada y segura
              </p>
              <ul className="space-y-3 text-sm text-stone-300" data-id="element-112">
                <li className="flex gap-2" data-id="element-113">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-114" />{' '}
                  Orden de instalación y buenas prácticas
                </li>
                <li className="flex gap-2" data-id="element-115">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-116" />{' '}
                  Cómo dejar canalizaciones y cajas bien planteadas
                </li>
                <li className="flex gap-2" data-id="element-117">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-118" />{' '}
                  Checklist de control visual y seguridad
                </li>
                <li className="flex gap-2" data-id="element-119">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0" data-id="element-120" />{' '}
                  Guías de orden y mantenimiento futuro
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-8 bg-stone-800/50 p-4 rounded-lg border border-stone-700 text-sm text-stone-400 text-center" data-id="element-121">
            <span className="font-bold text-yellow-500" data-id="element-122">Nota importante:</span>{' '}
            el módulo eléctrico está orientado a buenas prácticas y control.
            Para trabajos que requieran normativa o matrícula, corresponde
            profesional habilitado.
          </div>
        </div>
      </section>

      {/* Why Save Time/Money */}
      <section className="py-16 px-4 bg-white" data-id="element-123">
        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-124">
          <div data-id="element-125">
            <h3 className="text-2xl font-black text-stone-900 mb-6 flex items-center gap-3" data-id="element-126">
              <Clock className="w-8 h-8 text-orange-600" data-id="element-127" />
              ¿Por qué esto te hace ahorrar TIEMPO?
            </h3>
            <p className="text-stone-700 mb-4" data-id="element-128">
              Porque en vez de pensar "¿y ahora qué sigue? ", tenés:
            </p>
            <ul className="space-y-3 mb-6" data-id="element-129">
              {['paso a paso claro', 'checklist por etapa', 'puntos críticos marcados', 'control antes de avanzar (para no romper después)'].map((item, i) => <li key={i} className="flex items-center gap-2 font-medium text-stone-800" data-id="element-130">
                  <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-131" /> {item}
                </li>)}
            </ul>
            <p className="font-bold text-stone-900 bg-orange-100 p-3 rounded-lg inline-block" data-id="element-132">
              Resultado: menos vueltas, menos pausas, menos improvisación.
            </p>
          </div>

          <div data-id="element-133">
            <h3 className="text-2xl font-black text-stone-900 mb-6 flex items-center gap-3" data-id="element-134">
              <ShieldCheck className="w-8 h-8 text-green-600" data-id="element-135" />
              ¿Por qué esto te hace ahorrar DINERO?
            </h3>
            <p className="text-stone-700 mb-4" data-id="element-136">
              Porque los errores caros se repiten siempre:
            </p>
            <ul className="space-y-3 mb-6" data-id="element-137">
              {['cerrar y después romper', 'comprar materiales por segunda vez', 'rehacer terminaciones', 'perder días por detalles evitables', 'reclamos que te hacen volver "gratis"'].map((item, i) => <li key={i} className="flex items-center gap-2 font-medium text-stone-800" data-id="element-138">
                  <span className="text-red-500 font-bold" data-id="element-139">✕</span> {item}
                </li>)}
            </ul>
            <p className="font-bold text-stone-900 bg-green-100 p-3 rounded-lg inline-block" data-id="element-140">
              Cuando evitás eso, aparece la ganancia.
            </p>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 px-4 bg-stone-100 relative overflow-hidden" data-id="element-141">
        <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-stone-200 to-transparent opacity-50" data-id="element-142"></div>
        <div className="max-w-5xl mx-auto" data-id="element-143">
          <div className="text-center mb-12" data-id="element-144">
            <span className="bg-red-600 text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider mb-4 inline-block" data-id="element-145">
              GRATIS SOLO POR HOY
            </span>
            <h2 className="text-4xl font-black text-stone-900 mb-4" data-id="element-146">
              Bonos incluidos
            </h2>
            <p className="text-xl text-stone-600 max-w-2xl mx-auto" data-id="element-147">
              Además de los tomos, te llevás 3 bonos (uno por rubro), pensados
              para usar en obra desde el celular o impresos.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-148">
            {/* Bono 1 */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col hover:shadow-xl transition-shadow cursor-pointer" onClick={scrollToPurchase} data-id="element-149">
              <div className="relative" data-id="element-150">
                <img src="https://cdn.magicpatterns.com/uploads/dgRAGSSaCbE42r1HRQhcaw/ChatGPT_Image_19_ene_2026,_05_40_59_p.m..png" alt="Bono Albañilería" className="w-full h-auto object-cover" data-id="element-151" />
                <div className="absolute top-4 right-4 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded shadow" data-id="element-152">
                  GRATIS
                </div>
              </div>
              <div className="p-6 flex-1" data-id="element-153">
                <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-154">
                  ✅ BONO 1 — ALBAÑILERÍA (Pack Pro)
                </h3>
                <ul className="space-y-2 text-sm text-stone-600 mt-4" data-id="element-155">
                  <li className="flex gap-2" data-id="element-156">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-157" />{' '}
                    Checklists por etapa
                  </li>
                  <li className="flex gap-2" data-id="element-158">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-159" /> Lista
                    base de materiales
                  </li>
                  <li className="flex gap-2" data-id="element-160">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-161" />{' '}
                    Plantilla de presupuesto editable
                  </li>
                </ul>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col hover:shadow-xl transition-shadow cursor-pointer" onClick={scrollToPurchase} data-id="element-162">
              <div className="relative" data-id="element-163">
                <img src="https://cdn.magicpatterns.com/uploads/d8fLrQHXr7a9cxaMqQPE6v/ChatGPT_Image_19_ene_2026,_05_51_48_p.m..png" alt="Bono Plomería" className="w-full h-auto object-cover" data-id="element-164" />
                <div className="absolute top-4 right-4 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded shadow" data-id="element-165">
                  GRATIS
                </div>
              </div>
              <div className="p-6 flex-1" data-id="element-166">
                <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-167">
                  ✅ BONO 2 — PLOMERÍA (Pack Pro)
                </h3>
                <ul className="space-y-2 text-sm text-stone-600 mt-4" data-id="element-168">
                  <li className="flex gap-2" data-id="element-169">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-170" />{' '}
                    Checklists por etapa
                  </li>
                  <li className="flex gap-2" data-id="element-171">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-172" /> Lista
                    base de materiales
                  </li>
                  <li className="flex gap-2" data-id="element-173">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-174" />{' '}
                    Plantilla de presupuesto editable
                  </li>
                  <li className="flex gap-2" data-id="element-175">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-176" />{' '}
                    Checklist antes de tapar
                  </li>
                </ul>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col hover:shadow-xl transition-shadow cursor-pointer" onClick={scrollToPurchase} data-id="element-177">
              <div className="relative" data-id="element-178">
                <img src="https://cdn.magicpatterns.com/uploads/csxT5J2sKNkBVEiF6p3rZY/ChatGPT_Image_19_ene_2026,_05_56_28_p.m..png" alt="Bono Electricidad" className="w-full h-auto object-cover" data-id="element-179" />
                <div className="absolute top-4 right-4 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded shadow" data-id="element-180">
                  GRATIS
                </div>
              </div>
              <div className="p-6 flex-1" data-id="element-181">
                <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-182">
                  ✅ BONO 3 — ELECTRICIDAD (Pack Pro)
                </h3>
                <ul className="space-y-2 text-sm text-stone-600 mt-4" data-id="element-183">
                  <li className="flex gap-2" data-id="element-184">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-185" />{' '}
                    Checklists por etapa
                  </li>
                  <li className="flex gap-2" data-id="element-186">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-187" /> Lista
                    base de materiales
                  </li>
                  <li className="flex gap-2" data-id="element-188">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-189" />{' '}
                    Plantilla de presupuesto editable
                  </li>
                  <li className="flex gap-2" data-id="element-190">
                    <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-191" />{' '}
                    Checklist de control visual
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Transformation */}
      <section className="py-16 px-4 bg-stone-900 text-white text-center" data-id="element-192">
        <div className="max-w-3xl mx-auto" data-id="element-193">
          <h2 className="text-3xl font-black mb-10" data-id="element-194">
            Lo que cambia desde el primer día
          </h2>

          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-195">
            <div className="bg-red-900/30 p-6 rounded-xl border border-red-900/50" data-id="element-196">
              <p className="text-sm uppercase text-red-400 font-bold mb-4" data-id="element-197">
                Vas a pasar de:
              </p>
              <ul className="space-y-4 text-lg" data-id="element-198">
                <li className="flex items-center gap-3 justify-center text-red-200" data-id="element-199">
                  <span className="text-red-500 text-xl" data-id="element-200">❌</span> "vamos
                  viendo"
                </li>
                <li className="flex items-center gap-3 justify-center text-red-200" data-id="element-201">
                  <span className="text-red-500 text-xl" data-id="element-202">❌</span> "después lo
                  arreglamos"
                </li>
                <li className="flex items-center gap-3 justify-center text-red-200" data-id="element-203">
                  <span className="text-red-500 text-xl" data-id="element-204">❌</span> "rompamos y
                  rehagamos"
                </li>
              </ul>
            </div>

            <div className="hidden md:block" data-id="element-205">
              <ChevronRight className="w-12 h-12 text-stone-600 mx-auto" data-id="element-206" />
            </div>

            <div className="bg-green-900/30 p-6 rounded-xl border border-green-900/50" data-id="element-207">
              <p className="text-sm uppercase text-green-400 font-bold mb-4" data-id="element-208">
                A:
              </p>
              <ul className="space-y-4 text-lg" data-id="element-209">
                <li className="flex items-center gap-3 justify-center text-green-200" data-id="element-210">
                  <span className="text-green-500 text-xl" data-id="element-211">✅</span> "esto se
                  hace así"
                </li>
                <li className="flex items-center gap-3 justify-center text-green-200" data-id="element-212">
                  <span className="text-green-500 text-xl" data-id="element-213">✅</span> "esto se
                  revisa antes de cerrar"
                </li>
                <li className="flex items-center gap-3 justify-center text-green-200" data-id="element-214">
                  <span className="text-green-500 text-xl" data-id="element-215">✅</span> "esto evita
                  perder plata"
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 px-4 bg-white" data-id="element-216">
        <div className="max-w-6xl mx-auto" data-id="element-217">
          <h2 className="text-3xl font-black text-stone-900 mb-12 text-center" data-id="element-218">
            Lo que dicen quienes ya lo usan
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-219">
            <TestimonialCard name="Carlos" age={45} role="Albañil" location="Buenos Aires" content="Hace 20 años que estoy en obra, pero los checklists me salvaron de olvidarme pavadas que después cuestan caro. Muy útil para tener en el celular." data-id="element-220" />
            <TestimonialCard name="Mariano" age={38} role="Construyendo su casa" location="Córdoba" content="No tenía idea de nada y los albañiles me verseaban. Con esto pude controlar qué hacían y evitar que me hagan cualquier cosa. Se pagó solo." data-id="element-221" />
            <TestimonialCard name="Roberto" age={52} role="Contratista" location="Rosario" content="Lo compré para mis empleados. Ahora tienen una guía clara y no me llaman a cada rato para preguntar cosas básicas. Mejoró mucho el orden." data-id="element-222" />
            <div className="md:hidden" data-id="element-223">
              <TestimonialCard name="Julián" age={29} role="Constructor" location="Mendoza" content="La parte de electricidad es excelente para dejar todo listo antes de que venga el matriculado. Muy prolijo todo." data-id="element-224" />
            </div>
            <div className="md:hidden" data-id="element-225">
              <TestimonialCard name="Esteban" age={41} role="Electricista" location="La Plata" content="Los clientes valoran mucho cuando sos ordenado. Las planillas de presupuesto me ayudaron a pasar precios más profesionales." data-id="element-226" />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-stone-50" data-id="element-227">
        <div className="max-w-3xl mx-auto" data-id="element-228">
          <h2 className="text-3xl font-black text-stone-900 mb-10 text-center" data-id="element-229">
            Preguntas frecuentes
          </h2>

          <div className="space-y-6" data-id="element-230">
            {[{
            q: '¿Es físico o digital?',
            a: 'Digital. Descarga inmediata.'
          }, {
            q: '¿Sirve si estoy empezando?',
            a: 'Sí. Te ordena y te marca qué mirar para no fallar.'
          }, {
            q: '¿Sirve si tengo experiencia?',
            a: 'Sí. Porque los checklists evitan errores de apuro y estandarizan.'
          }, {
            q: '¿Cómo lo uso?',
            a: 'En obra: abrís el tomo del trabajo y seguís el paso a paso + checklist.'
          }].map((item, i) => <div key={i} className="bg-white p-6 rounded-lg shadow-sm border border-stone-200" data-id="element-231">
                <h3 className="font-bold text-lg text-stone-900 mb-2" data-id="element-232">
                  {item.q}
                </h3>
                <p className="text-stone-600" data-id="element-233">{item.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Purchase Section */}
      <section id="compra" className="py-20 px-4 bg-stone-900 text-white relative" data-id="element-234">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/concrete-wall.png')]" data-id="element-235"></div>
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-236">
          <div className="text-center mb-12" data-id="element-237">
            <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-238">
              Empezá a ahorrar tiempo y dinero hoy
            </h2>
            <p className="text-xl text-stone-300 max-w-2xl mx-auto" data-id="element-239">
              Si querés dejar de perder días y dejar de tirar plata en errores
              evitables, esto es para vos.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 items-end" data-id="element-240">
            {/* Basic Tier */}
            <PricingCard title="Pack Básico" price="19.999" originalPrice="49.990" features={['Biblia del Constructor (3 tomos)', 'Albañilería + Plomería + Electricidad', 'Todos los Checklists', 'Bonos de regalo incluidos']} link="https://checkout.solucionstore.shop/cart/44922306166975:1" buttonText="COMPRAR PACK BÁSICO" data-id="element-241" />

            {/* Pintura Tier (Popular) */}
            <PricingCard title="Pack + Pintura" price="27.990" originalPrice="59.990" features={['Todo lo del Pack Básico', 'Curso Completo de Pintura Profesional', 'Técnicas de preparación de superficies', 'Guía de acabados y terminaciones', 'Bonos extra de pintura']} link="https://checkout.solucionstore.shop/cart/44922441597119:1" isPopular={true} buttonText="COMPRAR PACK + PINTURA" data-id="element-242" />

            {/* Complete Tier */}
            <PricingCard title="Pack Constructor Total" price="39.990" originalPrice="69.990" features={['Todo lo del Pack Básico', 'Curso de Pintura Profesional', 'Curso de Carpintería de Obra', 'Megapack de Planos']} link="https://checkout.solucionstore.shop/cart/44922498449599:1" buttonText="COMPRAR PACK TOTAL" data-id="element-243" />
          </div>

          <div className="mt-12 text-center" data-id="element-244">
            <div className="flex items-center justify-center gap-4 text-sm text-stone-400" data-id="element-245">
              <span className="flex items-center gap-1" data-id="element-246">
                <ShieldCheck className="w-4 h-4" data-id="element-247" /> Compra Segura
              </span>
              <span className="flex items-center gap-1" data-id="element-248">
                <Zap className="w-4 h-4" data-id="element-249" /> Entrega Inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-250">
                <CheckCircle2 className="w-4 h-4" data-id="element-251" /> Garantía de Satisfacción
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-stone-500 py-8 px-4 text-center text-sm" data-id="element-252">
        <p data-id="element-253">
          © {new Date().getFullYear()} La Biblia del Constructor. Todos los
          derechos reservados.
        </p>
        <p className="mt-2" data-id="element-254">
          Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio no está respaldado por Facebook de ninguna manera.
        </p>
      </footer>
    </div>;
}
function Check(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-255">
      <polyline points="20 6 9 17 4 12" data-id="element-256" />
    </svg>;
}